import styled from 'styled-components';

const SpotifyWrapper = styled.div`
	text-align: center;
	margin: 0 auto 1rem auto;
`;

const FlowerImage = styled.img`
	width: 100%;
	margin-bottom: -3px;
	&:last-child {
		transform: rotate(180deg);
		margin-bottom: 0;
		margin-top: -3px;
	}
`;

export { SpotifyWrapper, FlowerImage };
